import { useState, useCallback } from 'react';
import { getESM2to1Stocks } from '@/lib/api/esm2to1StocksApi';
import { ESM2to1StockItem } from '@/types/esm2to1Stocks';

export function useESM2to1Stocks() {
  const [allStocks, setAllStocks] = useState<ESM2to1StockItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchESM2to1Stocks = useCallback(async (filters: Record<string, unknown>) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await getESM2to1Stocks(filters);
      setAllStocks(data);
      return data;
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Failed to load ESM 2-to-1 stocks. Please try again later.';
      setError(errorMessage);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    stocks: allStocks,
    loading,
    error,
    fetchESM2to1Stocks,
  };
}
